module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$emit("selected", _vm.item)
      }
    }
  }, [_c('v-list-tile-avatar', [(_vm.item.automatically_add_to_appointments) ? _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "slot": "activator",
      "color": "amber"
    },
    slot: "activator"
  }, [_vm._v("flash_on")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('info.auto_on')))])], 1) : _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "slot": "activator",
      "color": "green"
    },
    slot: "activator"
  }, [_vm._v("trip_origin")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('info.auto_off')))])], 1)], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [(_vm.item.practitioner) ? _c('practitioner-faces', {
    staticClass: "mr-2",
    attrs: {
      "size": 20,
      "practitioner-ids": [_vm.item.practitioner]
    }
  }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.item.icd10) + ". " + _vm._s(_vm.item.process) + " @\n      " + _vm._s(_vm.formatCurrency(_vm.item.currency, _vm.item.price)))])], 1), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n      " + _vm._s(_vm.luxonDateformat(_vm.item.start_date, 'ccc d MMM yyyy')) + "\n      "), (_vm.item.stop_date) ? _c('span', [_vm._v("\n        - " + _vm._s(_vm.luxonDateformat(_vm.item.stop_date, 'ccc d MMM yyyy')) + "\n      ")]) : _c('span', [_vm._v("until forever")]), _vm._v(" "), (_vm.isCurrent) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "color": "amber",
      "label": ""
    }
  }, [_vm._v("active")]) : _vm._e()], 1), _vm._v(" "), (_vm.item.automatically_add_to_appointments) ? _c('v-list-tile-sub-title', {
    staticClass: "hidden-xs-only"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n          Will be automatically added to appointments created between these dates\n      ")], 1) : _c('v-list-tile-sub-title', {
    staticClass: "hidden-xs-only"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n          Will "), _c('strong', [_vm._v("never")]), _vm._v(" be automatically added to appointments\n      ")], 1)], 1), _vm._v(" "), (_vm.withDelete) ? _vm._t("action", function() {
    return [_c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "disabled": !_vm.isOwner,
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$emit("selected", _vm.item)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "disabled": !_vm.isOwner,
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.dialogs.delete = true
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
      attrs: {
        "width": "290"
      },
      model: {
        value: (_vm.dialogs.delete),
        callback: function($$v) {
          _vm.$set(_vm.dialogs, "delete", $$v)
        },
        expression: "dialogs.delete"
      }
    }, [_c('v-card', [_c('v-card-text', [_vm._v("\n          " + _vm._s(_vm.$t('delete.confirm')) + "\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      attrs: {
        "flat": ""
      },
      on: {
        "click": function($event) {
          _vm.dialogs.delete = false
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('buttons.cancel')) + "\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "error"
      },
      on: {
        "click": function($event) {
          _vm.$emit("clicked:delete", _vm.item);
          _vm.dialogs.delete = false
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('buttons.delete')) + "\n          ")])], 1)], 1)], 1)]
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24d07372","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/medicalaid/TreatmentLogListItem.vue
// module id = 1360
// module chunks = 9